/*
* This file contains the constants used in the application.
* The AgentAdministrationServiceUrl is the base URL for the API.
* The WebsocketUrl is the URL for the WebSocket connection.
* The Environment object contains the username and password for the API.
* The AuthorizationService uses these constants to authenticate the user.
*/

// pre - prod
export const WebsocketUrl = "wss://mindxlivepreback.app/";
// export const AgentAdministrationServiceUrl = "https://mdxlivebk.app/";
// export const WebsocketUrl = "wss://mdxlivebk.app/";

export const Environment = {
  username: 'Axede',
  password: 'AxePassWord',
  appVersion: '1.0.0',
}
